// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-forecast';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.648 1.008V16.92h16.704' />
    <path d='M15.408 8.784c-.72 1.08-1.656 1.944-2.736 2.52s-2.376.936-3.6.936c-1.296 0-2.52-.36-3.6-.936s-2.016-1.44-2.736-2.52c-.072-.072-.072-.216-.072-.288s0-.216.072-.288C3.456 7.2 4.392 6.336 5.472 5.76s2.376-.936 3.6-.936c1.296 0 2.52.36 3.6.936s2.016 1.44 2.736 2.52c.072.072.072.216.072.288.072.072 0 .144-.072.216z' />
    <path d='M9 10.44c1.008 0 1.872-.864 1.872-1.872S10.008 6.696 9 6.696s-1.872.864-1.872 1.872S7.992 10.44 9 10.44zM.864 16.776 4.68 12.96m8.496-11.952h3.384v3.456m-2.808-.648 2.808-2.808' />
  </g>
);

export const viewBox = '0 0 18 18';
